export default function ({ app }, inject) {
  inject('validators', {
    time: {
      // Проверка заполненности полей времени
      areTimeFieldsFilled(startTime, endTime) {
        return startTime !== '' && endTime !== ''
      },

      // Проверка корректности интервала времени
      isTimeIntervalValid(startTime, endTime) {
        return startTime < endTime
      },

      isCorrectTimeData(startTime, endTime) {
        if (arguments.length !== 2) {
          return false
        }

        return (
          this.areTimeFieldsFilled(startTime, endTime) &&
          this.isTimeIntervalValid(startTime, endTime)
        )
      },
    },
  })
}
